<template>
	<div class="table-responsive">
		<table class="table table-striped table-vcenter">
			<thead>
				<tr>
					<th class="text-left">厂家名称</th>
					<th class="text-center">邮箱</th>
					<th class="text-center">联系人</th>
					<th class="text-center">联系电话</th>
					<th class="text-center">创建时间</th>
					<th class="text-center">操作</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for='(item, index) in items'>
					<td class="text-left">{{item.name}}</td>
					<td class="text-center">{{item.email}}</td>
					<td class="text-center">{{item.contact_person}}</td>
					<td class="text-center">{{item.contact_phone}}</td>
					<td class="text-center">{{$time(item.created_at).format('YYYY-MM-DD HH:mm')}}</td>
					<td class="text-center">
						<!-- <btn-tag 
							:href='"/factories/" + item.id' 
							text='详情'
							:key='Math.random()'
							:auth-id='31101' 
							icon-class='ion-information-circled'
							module-name='orders'>
						</btn-tag> -->
						<btn-tag 
							:href='"/factories/" + item.id +"/edit"' 
							text='编辑'
							:key='Math.random()'
							:auth-id='33102' 
							icon-class='ion-edit'
							module-name='orders'
						></btn-tag>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		props: {
			items: null,
		}
	}
</script>